import React, { useMemo } from "react";
import _ from "lodash";
import cx from 'classnames';
import { Course } from "src/types/coaching/courses";

import styles from "./content.module.scss";
import { EditLessonContent } from "./lesson";
import { EditAssessmentContent } from "./assessment";
import { CourseContext } from "../../context";
import Button from "src/components/button";

interface EditCourseContentProps {
  course: Course;
  contentIndex: number;

  // eslint-disable-next-line no-unused-vars
  onAddLessonClicked?: (parentUuid?: string | null) => void;

  // eslint-disable-next-line no-unused-vars
  onAddAssessmentClicked?: (parentUuid?: string | null) => void;

  // eslint-disable-next-line no-unused-vars
  onAddSectionClicked: (order: number) => void;
}

export const EditCourseContent: React.FC<EditCourseContentProps> = ({ course, onAddLessonClicked, onAddAssessmentClicked, onAddSectionClicked }) => {
  const courseContext = React.useContext(CourseContext);
  const courseContent = courseContext.courseContent;

  const entityType = useMemo(() => {
    return _.get(courseContent, "entityType");
  }, [courseContent]);


  if (!courseContent) {
    return <EmptyContentView course={course} onAddLessonClicked={onAddLessonClicked} onAddAssessmentClicked={onAddAssessmentClicked} onAddSectionClicked={() => onAddSectionClicked(1)} />;
  }

  return (
    <div className={styles.content}>
      {courseContent && entityType === "lesson" && (
        <EditLessonContent course={course} lesson={courseContent} />
      )}

      {courseContent && entityType === "assessment" && (
        <EditAssessmentContent course={course} assessment={courseContent} />
      )}
    </div>
  );
}

interface EmptyContentViewProps {
  course: Course;
  // eslint-disable-next-line no-unused-vars
  onAddLessonClicked?: (parentUuid?: string | null) => void;

  // eslint-disable-next-line no-unused-vars
  onAddAssessmentClicked?: (parentUuid?: string | null) => void;

  // eslint-disable-next-line no-unused-vars
  onAddSectionClicked: () => void;
}

const EmptyContentView: React.FC<EmptyContentViewProps> = ({
  course,
  onAddLessonClicked,
  onAddAssessmentClicked,
  onAddSectionClicked
}) => {

  const section = course?.contents?.find(c => c.entityType === 'section');

  return (
    <div className={styles.emptyContainer}>
      <div className={styles.heading}>nothing added yet!</div>
      <p className={styles.subText}>
        no lessons & assessments added to this course yet
      </p>

      <div className={styles.actions}>
        <Button variant="secondary" className={cx(styles.actionButton, styles.addContentButton)}
          icon="paperflite-add"
        >
          <span className={styles.text}>
            Add New
            <span className={styles.primary} onClick={() =>  onAddLessonClicked?.(section?.uuid)}>Lesson</span>
            <span className={styles.subtext}>or</span>
            <span className={styles.primary} onClick={() => onAddAssessmentClicked?.(section?.uuid)}>Assessment</span>
          </span>
        </Button>
        {_.size(course.contents) == 0 && 
          <Button variant="secondary" className={styles.actionButton}
            icon="paperflite-stack"
            onClick={onAddSectionClicked}
          >
            <span className={styles.text}>Add New <span className={styles.primary}>Section</span></span>
          </Button>
        }
      </div>
    </div>
  );
};
